import React from 'react'
import './style.css'
import cursorImg from "../../assets/cursor (2).png";

export default function Contact() {
  return (
    <div className='contact-container' style={{ cursor: `url(${cursorImg}), auto` }}>
        <div>
          <h2>Yo, yo, yo!</h2>
          <p>
            3-8-3 to the 4-9-3 to the 9-3 to the 1-1-0!
            <br/>Representing Creative Products.
            <br/>What up engineer?
          </p>
        </div>
        <a href="tel:+38349393110">leave it at the tone</a>
    </div>
  )
}
